/**
 * Author: Claude Code
 * Version: v3.2.17
 * Modified: 2025-10-03
 *
 * BettingLeaderboard - 下注排行榜（显示各Agent总下注额）
 */

import React from 'react';

export interface AgentBettingStats {
  agentId: number;
  name: string;
  character: string;
  status: 'active' | 'wait' | 'died';
  totalBets: number;
}

export interface BettingLeaderboardProps {
  isVisible: boolean;
  onClose?: () => void;
}

const mockBettingStats: AgentBettingStats[] = [
  { agentId: 4, name: 'Agent Delta', character: '🗡️', status: 'active', totalBets: 3200 },
  { agentId: 7, name: 'Agent Theta', character: '🪓', status: 'active', totalBets: 2800 },
  { agentId: 1, name: 'Agent Alpha', character: '⚔️', status: 'active', totalBets: 2500 },
  { agentId: 6, name: 'Agent Zeta', character: '💀', status: 'active', totalBets: 2100 },
  { agentId: 2, name: 'Agent Beta', character: '🏹', status: 'active', totalBets: 1800 },
  { agentId: 5, name: 'Agent Echo', character: '🛡️', status: 'wait', totalBets: 1500 },
  { agentId: 3, name: 'Agent Gamma', character: '🔮', status: 'died', totalBets: 900 }
];

export const BettingLeaderboard: React.FC<BettingLeaderboardProps> = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  const sortedBets = [...mockBettingStats].sort((a, b) => b.totalBets - a.totalBets);

  return (
    <div className="expanded-panel betting-leaderboard-panel">
      <div className="panel-header">
        <h3>💰 Betting Leaderboard</h3>
        {onClose && (
          <button className="close-btn" onClick={onClose}>✕</button>
        )}
      </div>
      <div className="panel-body">
        <div className="betting-header-row">
          <span className="col-rank">Rank</span>
          <span className="col-agent">Agent</span>
          <span className="col-bets">Total Bets</span>
        </div>
        <div className="betting-rows">
          {sortedBets.map((agent, i) => (
            <div key={agent.agentId} className="betting-row">
              <span className="col-rank">#{i + 1}</span>
              <span className={`col-agent ${agent.status === 'died' ? 'died' : ''}`}>
                <span className="agent-character">{agent.character}</span>
                <span className="agent-name">{agent.name}</span>
              </span>
              <span className="col-bets">{agent.totalBets.toLocaleString()} momo</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
